import './Navbar.css'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

export interface NavItemProps {
    path: string
    basePath?: string
    children?: NavItemProps[]
    parents?: string[]
    element?: any
}

export interface NavbarProps {
    basePath?: string
    navs: NavItemProps[]
}

function NavItem ( { basePath = "", path, children, parents, element }: NavItemProps ) {
    const { t } = useTranslation()
    const [ active, setActive ] = useState<boolean>( false )

    const handleClick = () => {
        setActive( !active )
    }

    var link: string = basePath
    var newParents: string[] = []
    if ( parents != null ) {
        parents.forEach( function ( p ) {
            link += "/" + p
            if ( p !== path ) {
                newParents.push( p )
            } else {
                console.warn( path )
            }
        } )
    }
    newParents.push( path )
    link += "/" + path
    // console.info( link )

    let span
    if ( element !== undefined ) {
        span = <NavLink className="nav-text" to={ link }>
            { ( { isActive, isPending } ) => {
                setActive( isActive )
                return <span className={ active ? "active" : "" }>{ t( path ) }</span>
            } }
        </NavLink>
    } else {
        span = <span className="nav-text" onClick={ handleClick }>{ t( path ) }</span>
    }
    return (
        <li className="nav-item">
            <div className={ `nav-item-with-sub` }>
                { span }
                { children && (
                    <ul className="sub-menu" style={ { display: active ? 'block' : 'none' } }>
                        { children.map( ( item, index ) => (
                            <NavItem basePath={ basePath } key={ index } path={ item.path } children={ item.children } parents={ newParents } element={ item.element } />
                        ) ) }
                    </ul>
                ) }
            </div>
        </li>
    )
}

function Navbar ( { basePath = "", navs }: NavbarProps ) {
    return (
        <nav className="navbar">
            <ul>
                { navs.map( ( nav, index ) => {
                    return <NavItem basePath={ basePath } key={ index } path={ nav.path } children={ nav.children } element={ nav.element } />
                } ) }
            </ul>
        </nav >
    )
}

export default Navbar
